import React from 'react';
import profile_bg from '../images/profile-bg.jpg'
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from './GroupTitle'
import './Profile.css'

export default function Profile() {
    return (
        <div className='profile'>
            <img className='profile-bg' src={profile_bg} alt='profile-bg'/>
            <GroupTitle className="profile-title">
                <GroupTitleBackground>company</GroupTitleBackground>
                <GroupTitleText>
                    <span>企业</span>
                    <GroupTitileOrange>介绍</GroupTitileOrange>
                </GroupTitleText>
            </GroupTitle>
            <div className='profile-text'>
                <p className='profile-text-title'>
                    国勘数字地球（北京）科技有限公司
                </p>
                <p className='profile-text-text'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国勘数字地球(北京)科技有限公司成立于2018年04月16日，注册地位于北京市昌平区回龙观镇建材城西路87号院8号楼20层1-2310，法定代表人为周艳伟。经营范围包括工程勘察；技术开发、技术推广、技术服务、技术转让、技术咨询；软件开发；基础软件服务、应用软件服务（不含医用软件）；数据处理（仅限PUE值在1.5以下）；工程和技术研究与试验发展；能源矿产地质勘查；租赁建筑工程机械设备；销售机械设备、计算机、软件及辅助设备。（企业依法自主选择经营项目，开展经营活动；工程勘察以及依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）国勘数字地球(北京)科技有限公司对外投资1家公司。
                </p>
            </div>
        </div>
    )
}